import React, {useEffect} from 'react'
import * as THREE from "three"
import { useTexture } from '@react-three/drei'
import { useSelector } from 'react-redux'
import { E_PedanaRivestimento } from '../Utils/enumerations'

// Crea i pezzettini di pavimentazione esterna alla pedana nel caso di ombrelloni con attacco esterno
export default function PavimentoEsterno({posizione}) {   
    const altezzaPedana = useSelector(state => state.uiPedanaMenu.realAltezza);
    const rivestimentoPavimento = useSelector(state => state.uiPedanaMenu.rivestimento);
    const shape = new THREE.Shape();

    const latoPavimentoEsterno = 0.3;

    const woodTexturesProps = useTexture({
        map: `${process.env.PUBLIC_URL}/textures/assiPavimento/PavimentoBasecolor.jpg`,
        normalMap: `${process.env.PUBLIC_URL}/textures/assiPavimento/PavimentoNormal.jpg`,
        roughnessMap: `${process.env.PUBLIC_URL}/textures/assiPavimento/PavimentoRoughness.jpg`,
        aoMap: `${process.env.PUBLIC_URL}/textures/assiPavimento/PavimentoAmbientOcclusion.jpg`,
        metalnessMap: `${process.env.PUBLIC_URL}/textures/assiPavimento/PavimentoMetallic.jpg`,
    })

    woodTexturesProps.map.repeat.set(0.65, 0.65);
    woodTexturesProps.normalMap.repeat.set(0.65, 0.65);
    woodTexturesProps.roughnessMap.repeat.set(0.65, 0.65);
    woodTexturesProps.aoMap.repeat.set(0.65, 0.65);
    woodTexturesProps.metalnessMap.repeat.set(0.65, 0.65);

    woodTexturesProps.map.wrapS = woodTexturesProps.map.wrapT = THREE.RepeatWrapping;
    woodTexturesProps.normalMap.wrapS = woodTexturesProps.normalMap.wrapT = THREE.RepeatWrapping;
    woodTexturesProps.roughnessMap.wrapS = woodTexturesProps.roughnessMap.wrapT = THREE.RepeatWrapping;
    woodTexturesProps.aoMap.wrapS = woodTexturesProps.aoMap.wrapT = THREE.RepeatWrapping;
    woodTexturesProps.metalnessMap.wrapS = woodTexturesProps.metalnessMap.wrapT = THREE.RepeatWrapping;

    const extrudeSettings = {
        steps: 2,
        depth: altezzaPedana * 1,
        bevelEnabled: true,
        bevelThickness: 0.005,
        bevelSize: 0.005,
        bevelOffset: -0.003,
        bevelSegments: 5,
    };

    // crea la forma della pavimentazione esterna
    const generatePavimentoEsterno = () => {
        shape.moveTo(-latoPavimentoEsterno, -latoPavimentoEsterno);
        shape.lineTo(latoPavimentoEsterno, -latoPavimentoEsterno);
        shape.lineTo(latoPavimentoEsterno, latoPavimentoEsterno);
        shape.lineTo(-latoPavimentoEsterno, latoPavimentoEsterno);
        shape.lineTo(-latoPavimentoEsterno, -latoPavimentoEsterno);                
        return shape;
    }
    
    useEffect(() => {     
        generatePavimentoEsterno();        
    }, []);    

    return (
        <mesh position={posizione} rotation={[Math.PI / 2, 0, 0]} >
            <extrudeGeometry args={[generatePavimentoEsterno(), extrudeSettings]} />
            {rivestimentoPavimento.toString() === E_PedanaRivestimento.WPC.toString() ? 
            <meshStandardMaterial {...woodTexturesProps} /> :
            <meshStandardMaterial {...woodTexturesProps} color={0xaa8888}/>} 
        </mesh>
    )
}
